<template>
  <div class="page-component-wrapper">
    <grid :config="gridConfig"/>
    <editor
      :disabled="isDisabledForm"
      :config="{id: gridConfig.id, api: 'Aircrafts/Get/'}"
    />
  </div>
</template>

<script>
import gridConfig from './GridConfig'

export default {
  name: 'AircraftsIndex',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'editor': () => import(/* webpackChunkName: 'Aircrafts' */ './Editor')
  },
  data () {
    return {
      gridConfig: gridConfig
    }
  },
  computed: {
    isDisabledForm () {
      return !this.permission(this.$store.getters.get('permissions'), 'isAllowToEditParts')
    }
  }
}
</script>
